module.exports = __webpack_public_path__ + "img/1b3b6aeefc752f8c4f85f88e5683c77a.png";